import React, { useEffect, useState } from "react";
import { Typography, Fade } from "@mui/material";
import styled from "styled-components";
import FounderPhoto from "../images/FounderPhoto.jpg";
import FoundersBluePhoto from "../images/FoundersBluePhoto.jpg";
import MedicalAssistants from "../images/MedicalAssistants.jpg";
import StaffDog from "../images/StaffDog.jpg";
import StaffPinkHearts from "../images/StaffPinkHearts.jpg";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CompanySocial = styled.img`
  width: 80%;
  border-radius: 10px;
`;

const ImgContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const words = [
  <CompanySocial src={StaffPinkHearts} />,
  <CompanySocial src={FounderPhoto} />,
  <CompanySocial src={FoundersBluePhoto} />,
  <CompanySocial src={StaffDog} />,
  <CompanySocial src={MedicalAssistants} />,
];

const WordCarousel: React.FC = () => {
  const [index, setIndex] = useState(0);
  const [show, setShow] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setShow(false); // start fade-out
      setTimeout(() => {
        setIndex((prevIndex) => (prevIndex + 1) % words.length);
        setShow(true); // start fade-in
      }, 300); // fade duration
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Container className="WordCarousel">
      <Fade in={show} timeout={500}>
        <Typography variant="h3" sx={{ color: "rgb(197 59 108)" }}>
          <ImgContainer>{words[index]}</ImgContainer>
        </Typography>
      </Fade>
    </Container>
  );
};

export default WordCarousel;
